import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/documentation/activity-specific-questions')({
  component: () => <Navigate replace search to="/bo/documentation/activity-specific-questions" />,
})
